<template>
	<div class="blog" v-if="document">
		<div class="container">
			<h1>{{ document.title }}</h1>
		</div>
		<c-paginate
			:itemList='currentItems'
			:currentPage='currentPage'
			:totalItems='blog.totalItems'
			:requestNext='requestPage'
			:requestLast='requestPage'
		/>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import * as utils from '@/utils/utils';
import defaultHeadData from '@/utils/defaultHeadData';
import { getBlogPageData } from '@/api/blog.wp.api';
import CBlogPostsList from '@/components/BlogPostsList';
import CPaginate from '@/components/Paginate';

export default {
	name: 'blog',
	components: {
		CBlogPostsList,
		CPaginate
	},
	data: () => ({
		documentData: null,
		headData: defaultHeadData,
		currentPage: 1
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta
		},
		siteSettings() {
			return this.$store.state.general.siteSettings
		},
		activeRouteUrl() {
			return utils.constructActiveRouteUrl(this.$route.fullPath)
		},
		document() {
			return this.documentData
		},
		...mapState(['blog']),
		currentItems() {
			const offset = this.blog.pageSize * (this.currentPage - 1)
			const max = Math.min(offset + this.blog.pageSize, this.blog.totalItems)
			return this.blog.postsList.slice(offset, max)
		}
	},
	created() {
		this.fetchPostsData();
	},
	watch: {
		'$route': function() {
			this.setBlogPageData()
			this.updateHeadData()
			this.fetchPostsData()
		},
		defaultMeta: function() {
			this.updateHeadData()
		}
	},
	head: {
		title: function() {
			return utils.transformHeadTitle(this.headData.title)
		},
		meta: function() {
			return utils.transformHeadMeta(this.headData.meta)
		},
		link: function() {
			return utils.transformHeadLink({ data: this.headData.link, i18n: false })
		}
	},
	beforeMount() {
		this.setBlogPageData()
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/blog' })
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en' })
	},
	methods: {
		fetchPostsData() {
			this.requestPage(parseInt(this.$route.query.page, 10) || 1)
		},
		requestPage(pageNumber) {
			this.$store.dispatch('loadPosts', { page: pageNumber })
			.then(() => {
				this.currentPage = pageNumber
			})
			.catch((error) => {
				this.$router.push({ path: '/404' })
			})
		},
		setBlogPageData() {
			this.documentData = null
			getBlogPageData({ lang: this.settings.currentLang }).then(payload => {
				this.documentData = payload
				utils.setHtmlLang(this.settings.currentLang)
				this.updateHeadData()
			})
			.catch(() => {
				this.$router.push({ path: '/404' })
			})
		},
		updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = utils.transformHeadData({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				})
				this.$emit('updateHead')
			}
		}
	}
}
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.blog {
		padding-bottom: 4rem;
		padding-top: 3rem;

		h1 {
			max-width: 30rem;
		}
	}

</style>



// WEBPACK FOOTER //
// Blog.vue?20d48854